import * as React from "react";
import Match from "bracket-system/components/match";
import FreeformBracket from "bracket-system/bracket-freeform/freeform-bracket";
import { getBracketOptions } from "common/helpers/bracketHelper";

// Shared bounty bracket surface; read-only unless the editor passes onPartyClick.
export default function BountyBracket({
    parts,
    svgWrapper,
    onPartyClick,
    hideSeriesScore,
}) {
    return (
        <FreeformBracket
            parts={parts}
            matches={parts}
            officialMatches={[]}
            matchComponent={Match}
            options={getBracketOptions()}
            svgWrapper={svgWrapper}
            hideSeriesScore={hideSeriesScore}
            onPartyClick={onPartyClick}
            horizontalParts
        />
    );
}
